import {IMenuLink} from "data/types/navigation";
import ExternalLink from "assets/img/icons/external_link.svg?react";
import {pickemLink} from "./header";
import {HP_PATH, LP_PATH} from "data/constants/index";

export const MENU_LINKS: IMenuLink[] = [
	{
		name: "header.nav.lp",
		url: LP_PATH,
	},
	{
		name: "header.nav.hp",
		url: HP_PATH,
	},
	{
		name: "header.nav.help",
		url: "/help",
	},
	{
		name: "header.nav.pickem",
		url: pickemLink,
		Icon: ExternalLink,
	},
	/*{
		name: "header.nav.sbc",
		url: "https://superbowlchallenge.co.uk/",
		Icon: ExternalLink,
	},*/
].filter(({url}) => url);
